import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  editAccessRestrictions(
    request: Boundaries["editAccessRestrictions"]["request"],
  ): void;
}

function useEditAccessRestrictions(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isEditAccessRestrictionsRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isEditAccessRestrictionsRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isEditAccessRestrictionsRequestFailure,
    ),
    editAccessRestrictions: core.editAccessRestrictions,
  };
}

export { useEditAccessRestrictions };
